import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const Logout = () => {
  const { logoutUser } = useContext(AuthContext)
  logoutUser()
  return (
    <Navigate to="/login" replace />
  )
}

export default Logout;